var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingAssetRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 120,
    viewBox: "0 0 108 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.66523 2.28882e-05L107.938 120V2.28882e-05H0.66523Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5455 -0.000526428L107.545 84.5449V-0.000526428H27.5455Z",
    fill: "#D9D8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.9088 28.1816L13.9089 -0.000169754H34.8177L49.8179 15.5484L38.9088 28.1816Z",
    fill: "#818CF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2727 78.6365L108 101.818V78.6365L94.8181 66.8184L85.2727 78.6365Z",
    fill: "#26364D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0908 0.000888824L108 49.0918V0.000888824H62.0908Z",
    fill: "#26364D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.8183 36.8185L108 68.6367V8.18219L79.8183 36.8185Z",
    fill: "#818CF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.273 20.9082L47.0914 -0.00088501H85.7275L65.273 20.9082Z",
    fill: "#818CF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingAssetRight);
export default __webpack_public_path__ + "static/media/floating-asset-right.613948a817113f4114559827525b8817.svg";
export { ForwardRef as ReactComponent };